import { GET_LOGS, GET_NEXT_LOG_PAGE, TOGGLE_LOADING, CLEAR_LOG, GET_LOG_ITEM, GET_ATTACHMENT_LOGS, CLEAR_ATTACHMENT_LOGS } from "./types";
import { getBaseURL } from "../../env/stage";
import { get, del } from "../../common/modules/http.client";
export const getExecutionLog =
  (
    flowId: string | null = null,
    startDate: number | null = null,
    endDate: number | null = null,
    lastTimeStamp: number | null = null,
    actionId: string | null = null
  ) =>
  (dispatch: any) => {
    const params = new URLSearchParams();

    if (flowId) {
      params.append("flowId", flowId);
    }
    if (startDate !== null && startDate !== undefined) {
      params.append("start", startDate.toString());
    }
    if (endDate !== null && endDate !== undefined) {
      params.append("end", endDate.toString());
    }
    if (lastTimeStamp !== null && lastTimeStamp !== undefined) {
      params.append("lastTimeStamp", lastTimeStamp.toString());
    }
    if (actionId) {
      params.append("actionId", actionId);
    }

    const LOG_URL = `${getBaseURL()}/logs?${params.toString()}`;
    const TYPE = lastTimeStamp == null ? GET_LOGS : GET_NEXT_LOG_PAGE;
    get(LOG_URL).then((res) => {
      dispatch({
        type: TYPE,
        payload: {
          ...res,
          flowId,
          actionId: actionId || undefined,
          currentTime: Date.now(),
        },
      });
      dispatch({
        type: TOGGLE_LOADING,
        payload: { status: false, loadingMessage: "" },
      });
    });
  };
export const clearLog = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_LOG,
    payload: [],
  });
};
export const deleteLogsForFlow = (flowId: string) => (dispatch: any) => {
  let LOG_URL = getBaseURL() + "/logs/" + flowId;
  del(LOG_URL).then((res) => {
    dispatch({
      type: CLEAR_LOG,
      payload: [],
    });
  });
};
export const getLogItem = (flowId: string, logKey: string) => (dispatch: any) => {
  const LOG_URL = getBaseURL() + "/log?&flowId=" + flowId + "&logKey=" + logKey;

  get(LOG_URL)
    .then((res) => resolveLogData(res))
    .then((data) => {
      if (!data) {
        return;
      }
      dispatch({
        type: GET_LOG_ITEM,
        payload: {
          logKey: logKey,
          data,
        },
      });
      dispatch({
        type: TOGGLE_LOADING,
        payload: { status: false, loadingMessage: "loading..." },
      });
    });
};

const resolveLogData = async (payload: any) => {
  if (!payload?.presignedUrl) {
    return payload;
  }

  const response = await fetch(payload.presignedUrl);
  const body = await response.text();
  try {
    return JSON.parse(body);
  } catch (error) {
    console.error("Failed to parse log from presigned url", error);
    return body;
  }
};

export const getAttachmentLogsForAction = (flowId: string, actionId?: string, context?: string) => (dispatch: any) => {
  const params = new URLSearchParams();
  if (flowId) {
    params.append("flowId", flowId);
  }
  if (actionId) {
    params.append("actionId", actionId);
  }
  if (context) {
    params.append("context", context);
  }

  const LOG_URL = `${getBaseURL()}/logs/attachments?${params.toString()}`;

  return get(LOG_URL).then((res) => {
    dispatch({
      type: GET_ATTACHMENT_LOGS,
      payload: res,
    });
    return res;
  });
};

export const clearAttachmentLogs = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_ATTACHMENT_LOGS,
  });
};
